"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoService = void 0;
var tslib_1 = require("tslib");
var queries_1 = require("./queries");
var base_public_service_1 = require("../base-public-service");
var play_urls_1 = require("../../mappers/play-urls");
var mappers_1 = require("../channel/mappers");
var PublicVideoService = /** @class */ (function (_super) {
    tslib_1.__extends(PublicVideoService, _super);
    function PublicVideoService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicVideoService.prototype.getDownloadUrl = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_DOWNLOAD_URL, { id: id })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.video.download.entity.url];
                }
            });
        });
    };
    PublicVideoService.prototype.getPlayUrls = function (variables) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_SINGLE_VIDEO_PLAY_URLS, variables)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, (0, play_urls_1.toPlayUrls)(result.video.play.entity.hls)];
                }
            });
        });
    };
    PublicVideoService.prototype.getVideo = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var video;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_PUBLIC_VIDEO, {
                            id: id,
                        })];
                    case 1:
                        video = (_a.sent()).video;
                        return [2 /*return*/, (0, mappers_1.mapGqlPublicVideoToOld)(video)];
                }
            });
        });
    };
    return PublicVideoService;
}(base_public_service_1.BasePublicService));
exports.PublicVideoService = PublicVideoService;
//# sourceMappingURL=video.js.map